import { makeHttpClient, _unwrapAxiosResponse } from "./http";
import env from "@/environment/env.json";
import { DialogProgrammatic as Dialog } from "buefy";
export default class CustomerReportService {
  private httpClient = makeHttpClient();

  export(customerId: any) {
    const url = `${env.customerUrl}export-customer-reports/?customer_id=${customerId}`;
    this.httpClient
      .get(url, { responseType: "blob" })
      .then(({ data }) => {
        const downloadUrl = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", "CustomerReports.xlsx"); //any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch(err => {
        Dialog.alert({
          title: "Export not possible",
          message:
            "There was an error exporting customer reports. Please contact your Customer Account Manager.",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
        return err;
      });
  }
}
